import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

/**
 * Fetch tenant configuration by tenant slug
 * @param {string} tenantSlug - The unique identifier for the tenant
 * @param {string} [recaptchaToken=''] - reCAPTCHA token for validation
 * @returns {Promise<Object>} Tenant configuration including logo, theme, etc.
 */
export const getTenantConfig = async (tenantSlug, recaptchaToken = '') => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };

    // Add reCAPTCHA token to headers if provided
    if (recaptchaToken) {
      headers['x-recaptcha'] = recaptchaToken;
    }

    const response = await axios.get(
      `${API_BASE_URL}/api/${tenantSlug}/tenant`,
      {
        headers,
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching tenant config:', error);
    throw error;
  }
};
